import Card from './Card'

const ResultsList = ({
  searchData,
  setDealer,
  onSelectDealerID,
  scrollRef,
  selectedDealerId,
}) => {
  return (
    <div
      id="resultsList"
      className="max-h-[565px] mx-auto md:overflow-auto"
      ref={scrollRef}
    >
      {searchData.map((dealer, index) => (
        <Card
          key={dealer.id}
          dealer={dealer}
          setDealer={setDealer}
          isSelected={selectedDealerId === dealer.localDealerID}
          cardNumber={index + 1}
          onSelectDealerID={onSelectDealerID}
          scrollRef={scrollRef}
        />
      ))}
    </div>
  )
}

export default ResultsList
